export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      d="M12 19.6H3C1.56406 19.6 0.4 18.4359 0.4 17V3C0.4 1.56406 1.56406 0.4 3 0.4H6.25736C6.94692 0.4 7.60824 0.673928 8.09584 1.16152L13.8385 6.90416C14.3261 7.39176 14.6 8.05308 14.6 8.74264V17C14.6 18.4359 13.4359 19.6 12 19.6Z"
      fill="white"
      stroke="#1F2A37"
      strokeWidth="0.8"
    />
    <rect
      x="3"
      y="13"
      width="9"
      height="4"
      rx="1"
      fill="#FDC8D3"
      stroke="#1F2A37"
      strokeWidth="0.8"
    />
    <path d="M7 0.5L14.5 8H9C7.89543 8 7 7.10457 7 6V0.5Z" fill="#FDC8D3" />
    <path
      d="M7 0.5V6C7 7.10457 7.89543 8 9 8H14.5"
      stroke="#1F2A37"
      strokeWidth="0.8"
      strokeLinejoin="round"
    />
  </svg>
);
